<carousel class="carousel-component"
          [class.is-empty]="!component.slides.length"
          [loop]="component.loop"
          [autoplay]="component.autoplay ? { delay: component.interval} : false"
          [pagination]="component.pagination"
          [navigation]="component.arrows ? {
                      nextEl: '.carousel-next-' + uid,
                      prevEl: '.carousel-prev-' + uid
                  } : false"
          [scrollbar]="component.progress">
    @for (slide of component.slides; track $index) {
    <ng-template carouselSlide>
        <div [ngClass]="[((!slide.custom && component.ratio) ? component.ratio : '')]">
            @if (!slide.custom) {
            <img [dfImage]="slide.image"
                 [priority]="slide.cwvLoading === 'eager' || slide.cwvPriority"
                 [ratio]="component.ratio"
                 fill>
            } @else {
            <icms-outlet [components]="slide.components" />
            }
        </div>
    </ng-template>
    }
    <!-- navigation -->
    @if (component.slides.length > 1 && component.arrows) {
    <div slot="container-start">
        <button class="pos-absolute top-50 left-4 z-5"
                [ngClass]="'carousel-prev-' + uid"
                type="button"
                [attr.aria-label]="'Previous slide' | translate">
            <i class="icon-chevron-left fs-6"
               aria-hidden="true"></i>
        </button>
        <button class="pos-absolute top-50 right-4 z-5"
                [ngClass]="'carousel-next-' + uid"
                type="button"
                [attr.aria-label]="'Next slide' | translate">
            <i class="icon-chevron-right fs-6"
               aria-hidden="true"></i>
        </button>
    </div>
    }
</carousel>